import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getReadNumNormal } from '@src/services/api';
import { h5PageCount } from 'ThreeTerminal_utils';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';

class OppCutOff extends React.PureComponent {
    static propTypes = {
        pageType: PropTypes.string,
        base62Id: PropTypes.string,
        createTime: PropTypes.string,
    };

    state = {
        readNum: 0,
        wxLaunchHackData: {}
    };

    componentDidMount() {
        const { pageType, base62Id } = this.props;

        h5PageCount([
            {
                behavior: 'action',
                type: 'oppowatch_open',
                other: {
                    id: `ucms_${base62Id}`,
                },
            },
        ]);

        this.getReadNumHandle();
        this.setState({
            wxLaunchHackData: {
                callAppConfig: {
                    docType: pageType,
                    pid: base62Id,
                    kind: 'brand_oppl11',
                    noKindFrom: 1,
                    download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7271573017562501120',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9178'
                },
                callAppClick: () => {
                    h5PageCount([
                        {
                            behavior: 'action',
                            type: 'oppowatch_dl',
                            other: {
                                id: `ucms_${base62Id}`,
                            },
                        },
                    ]);
                }
            }
        });
    }
    
    getReadNumHandle = async () => {
        const { base62Id, createTime } = this.props;
        let publishTime = createTime?.replace(/-/g, '/');

        publishTime = new Date(publishTime).getTime() || new Date().getTime();
        publishTime = Math.floor(publishTime / 1000);
        const readNum = await getReadNumNormal(base62Id, publishTime);

        this.setState({
            readNum,
        });
    };

    render() {
        const { readNum, wxLaunchHackData } = this.state;

        return (
            <div className={styles.articleCutoff}>
                {readNum ? (
                    <div className={styles.articleShadowNum}>
                        <div className={styles.articleShadowText}>
                            已有<span className={styles.articleShadowTextRed}>{readNum}</span>人解锁该文章
                        </div>
                    </div>
                ) : null}
                <div className={styles.articleCutoffTipBoxB}>
                    <div className={styles.articleCutoffTipButton}>点击解锁手表文章阅读</div>
                </div>
                {wxLaunchHackData?.callAppConfig && (
                    <WxLaunchHack content={wxLaunchHackData} />
                )}
            </div>
        );
    }
}

export default errorBoundary(OppCutOff);
